import React, { Component } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import ProfileHeader from "./ProfileHeader";
import Submenu from "./Submenu";
import getMyNotificationsCount from "../../../_selectors/userSelectors/getMyNotificationsCount";
import { map } from "lodash";
import getMyInvitationsReceivedCount from "../../../_selectors/userSelectors/getMyInvitationsReceivedCount";
import getMyProfileVisitorsCount from "../../../_selectors/userSelectors/getMyProfileVisitorsCount";
import getMyLikesNotificationCount from "../../../_selectors/userSelectors/getMyLikesNotificationCount";
import getMyInterestsCount from "../../../_selectors/userSelectors/getMyInterestsCount";
import getMyConnectedMembersCount from "../../../_selectors/userSelectors/getMyConnectedMembersCount";

class Sidebar extends Component {
  render() {
    const {
      notifications,
      invitationsReceived,
      profileVisitors,
      likedMe,
      interests,
      connects
    } = this.props;


    const ITEMS = [
      { title: true, label: "" },
      {
        icon: "home",
        label: "Home",
        to: "/",
        submenu: [],
        active: false
      },
      {
        icon: "user",
        label: "Profile",
        to: "/",
        notifications,
        submenu: [
          
        ],
        active: false
      },
      {
        icon: "picture-o",
        label: "Gallery",
        to: "/gallery",
        submenu: [],
        active: false
      },
      {
        icon: "newspaper-o",
        label: "My Activity",
        to: "/",
        submenu: [
          
        ],
        active: false
      },
      {
        icon: "globe",
        label: "Explore",
        to: "/",
        submenu: [
        ],
        active: false
      },
      {
        icon: "cubes",
        label: "FAQ",
        to: "/frequently-asked-questions",
        submenu: [],
        active: false
      },
      { title: true, label: "AMST Admin" }
    ];
    return (
      <div class="dev-page-sidebar">
        <ul class="dev-page-navigation">
          {map(ITEMS, item => {
            if (item.title) {
              return <li className="title text-center"> {item.label}</li>;
            }
            if (item.submenu.length === 0) {
              if (item.to) {
                return (
                  <li>
                    <Link to={item.to}>
                      <i className={`fa fa-${item.icon}`} />
                      <span>{item.label}</span>
                    </Link>
                  </li>
                );
              } else {
                return (
                  <li>
                    <a onClick={item.onClick}>
                      <i className={`fa fa-${item.icon}`} />
                      <span>{item.label}</span>
                    </a>
                  </li>
                );
              }
            } else {
              return <Submenu item={item} />;
            }
          })}
        </ul>
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => ({
  notifications: getMyNotificationsCount(state),
  invitationsReceived: getMyInvitationsReceivedCount(state),
  profileVisitors: getMyProfileVisitorsCount(state),
  likedMe: getMyLikesNotificationCount(state),
  interests: getMyInterestsCount(state),
  connects: getMyConnectedMembersCount(state)
});

export default connect(mapStateToProps)(Sidebar);



// WEBPACK FOOTER //
// ./src/_components/Layout/Sidebar/index.js